import React from "react";
import styled from "styled-components";
import { data } from "./data";

export default function PrivacyPolicy() {
  return (
    <div className="max-w-5xl mt-16 mb-16 break-all px-12 mx-auto">
      <div id="hello"></div>
      {data.map((r) => (
        <>
          <p className="font-bold text-xl mt-10 mb-3">{r.title}</p>
          <div className="border-solid border-2 border-gray-400 p-5">
            {r.content.map((c) => (
              <p className="mt-2">{c.text}</p>
            ))}
          </div>
        </>
      ))}
    </div>
  );
}
